import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let getProductPageDataMachine: any;

export const useSMGetProductPageData = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getProductPageDataMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getProductPageDataMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    getProductPageDataMachine,
    getProductPageDataMachineState: state,
    getProductPageDataMachineSend: send,
  };
};
